import { render, staticRenderFns } from "./TitleSuperAdmin.vue?vue&type=template&id=073aad1f&scoped=true&"
import script from "./TitleSuperAdmin.vue?vue&type=script&lang=js&"
export * from "./TitleSuperAdmin.vue?vue&type=script&lang=js&"
import style0 from "./TitleSuperAdmin.vue?vue&type=style&index=0&id=073aad1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073aad1f",
  null
  
)

export default component.exports